module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/beauty-pass-black-tier-0d0e2fa517a5c98d7b0c7e924bd38c06.png";